module.exports = __webpack_public_path__ + "static/media/fast_roulette_end.e62f3c9d.wav";